import { formatISODuration } from 'date-fns';

export default (unit, time) => formatISODuration({ [unit]: time });
